import React, { useRef, useState } from "react";
import "./index.scss";
import iconLoa from "../../../../assets/images/event-2024/icon-loa.png";
import { Empty, Table } from "antd";
import img100winner from "../../../../assets/images/event-2024/100 Winners.png";
import IconPineTree from "../../../../assets/images/event-2024/icon-pine-tree.png";
import IconTitleChristmas from "../../../../assets/images/event-2024/icon-title-christmas-Tree1.png";
import GiftSupper from "../Components/GiftSupper";
import iconTreeOpacity from "../../../../assets/images/event-2024/icon-tree-opacity.png";
import iconSnow from "../../../../assets/images/event-2024/icon-snow.svg";
import iconGiftTree1 from "../../../../assets/images/event-2024/icon-gift-tree-1.png";
import iconGiftTree3 from "../../../../assets/images/event-2024/icon-gift-tree-3.png";
import iconGiftTree5 from "../../../../assets/images/event-2024/icon-gift-tree-5.png";
import iconSnowMan from "../../../../assets/images/event-2024/icon-snow-man.png";
import iconTitleHistory from "../../../../assets/images/event-2024/icon-title-history.png";
import iconHistoryTree from "../../../../assets/images/event-2024/icon-tree-table.png";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import {
  getBidProduct,
  getCheckStatusEvent,
  getHistoryEventNoel,
} from "dataLayer/product";
import moment from "moment";
import { useStartOpenEventNoel } from "dataLayer/user";
import { ID_GIFT_EVENT_2024 } from "@config/constants/helper";
import iconErrorSupertGift from "../../../../assets/images/event-2024/popup/c-pop-up-2.png";
import iconErrorGift from "../../../../assets/images/event-2024/popup/c-pop-up-1.png";
import PopupComponents from "../Components/PopupComponents";
import { useHistory } from "react-router-dom";
import iconSparkSuccess from "../../../../assets/images/event-2024/popup/c-pop-up-4.png";
import iconShellSuccess from "../../../../assets/images/event-2024/popup/c-pop-up-5.png";
import iconBidSuccess from "../../../../assets/images/event-2024/popup/c-pop-up-6.png";
import { PATHS } from "@config/constants";
import iconGoodLuckSuccess from "../../../../assets/images/event-2024/popup/c-pop-up-7.png";
import iconSpecialSuccess from "../../../../assets/images/event-2024/popup/c-pop-up-8.png";
import Snow from "../Components/animtion/Snow";
import { isLoggedIn } from "@utils/cookie";
import iconErrorPopup from "../../../../assets/images/event-2024/popup/c-pop-up-3.png";
import PopupLogin from "../Components/PopupLogin";

export default function ChristmasTree() {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: historyEventNoel = {}, refetch } = useQuery(
    getHistoryEventNoel()
  );
  const { data: statusEvent, refetch: refetchStatus } = useQuery(
    getCheckStatusEvent()
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const { resultHistory = [], resultSpeHis = [] } = historyEventNoel;
  const dataPopUp = useRef({
    backgroundPopup: "",
    title: "",
    btnAction: {
      action: () => {},
      title: "",
    },
    description: "",
  });

  const {
    mutate: mutateOpenGift,
    data,
    isSuccess,
    error,
    isLoading: isLoadingOpenGift,
  } = useStartOpenEventNoel();

  const columns = [
    {
      title: t("event_2024.christmas-tree.rank"),
      dataIndex: "key",
      key: "key",
      render: (_, record) => {
        return <div>{+_ + 1}</div>;
      },
    },
    {
      title: t("event_2024.christmas-tree.isdn"),
      dataIndex: "isdn",
      key: "isdn",
    },
    {
      title: t("event_2024.christmas-tree.time"),
      dataIndex: "open_time",
      key: "open_time",
      render: (_ = "", record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        return (
          <div className="timer-table-history">
            <div>{datePart || ""}</div>
            <div>{timePart || ""}</div>
          </div>
        );
      },
    },
  ];

  const columnsSpin = [
    {
      title: t("event_2024.christmas-tree.rank"),
      dataIndex: "key",
      key: "key",
      render: (_, record) => {
        return <div>{+_ + 1}</div>;
      },
    },
    {
      title: t("event_2024.christmas-tree.isdn"),
      dataIndex: "isdn",
      key: "isdn",
    },
    {
      title: t("event_2024.christmas-tree.prize"),
      dataIndex: "award_name",
      key: "award_name",
    },
    {
      title: t("event_2024.christmas-tree.time"),
      dataIndex: "open_time",
      key: "open_time",
      render: (_ = "", record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        return (
          <div className="timer-table-history">
            <div>{datePart || ""}</div>
            <div>{timePart || ""}</div>
          </div>
        );
      },
    },
  ];

  let dataNoti = {};

  if (resultHistory.length !== 0) {
    dataNoti = resultHistory[0];
  }

  const handleOpenGift = (isSuper) => {
    const isLogin = isLoggedIn();
    if (!isLogin) {
      return setIsModalOpen(true);
    }
    if (isLoadingOpenGift) {
      return;
    }

    if (!statusEvent.open_super_left && !statusEvent.open_left) {
      dataPopUp.current = {
        backgroundPopup: iconErrorPopup,
        title:
          "¡Te has quedado sin Cajas Navideñas! ¡Inicia sesión mañana para reclamar 3 Cajas Navideñas Normales GRATIS o llega la meta de encender los Espectáculos de Fuegos Artificiales (50, 100 y más) para desbloquear Súper Cajas Navideñas con más recompensas premium!",
        btnAction: {
          action: () => {
            setOpen(false);
          },
          title: "Cerrar",
        },
        description:
          "La caja ROJA es la Súper Caja Navideña. La caja BLANCA es la Caja Navideña Normal.",
      };
      return setOpen(true);
    } else {
      if (
        !statusEvent.open_super_left &&
        isSuper === ID_GIFT_EVENT_2024.superGift
      ) {
        // hết mở hộp quà to
        dataPopUp.current = {
          backgroundPopup: iconErrorSupertGift,
          title:
            "¡Te has quedado sin Súper Cajas Navideñas! ¡Abre una Caja Navideña Normal o alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener más Súper Cajas Navideñas llenas de recompensas premium!",
          btnAction: {
            action: () => {
              setOpen(false);
            },
            title: "Cerrar",
          },
          description:
            "La caja ROJA es la Súper Caja Navideña. La caja BLANCA es la Caja Navideña Normal.",
        };
        return setOpen(true);
      }
      if (!statusEvent.open_left && isSuper !== ID_GIFT_EVENT_2024.superGift) {
        // hết số lần mở hộp quà nhỏ
        dataPopUp.current = {
          backgroundPopup: iconErrorGift,
          title:
            "¡Te has quedado sin Cajas Navideñas Normales! Abra una Súper Caja Navideña ahora o inicia sesión mañana para recibir 3 Cajas Navideñas Normales GRATIS",
          btnAction: {
            action: () => {
              setOpen(false);
            },
            title: "Cerrar",
          },
          description:
            "La caja ROJA es la Súper Caja Navideña. La caja BLANCA es la Caja Navideña Normal.",
        };
        return setOpen(true);
      }
    }
    // thành công
    mutateOpenGift(
      { isSuper: isSuper },
      {
        onSuccess: (data) => {
          if (data.data.award) {
            refetch();
            refetchStatus();

            switch (data.data.award.type) {
              case "SPARK":
                dataPopUp.current = {
                  backgroundPopup: iconSparkSuccess,
                  title: `Conseguiste ${data.data.award.value} Fósforos! ¡Compra más paquetes para encender más Fuegos Artificiales para iluminar la noche con un colorido Espectáculo de Fuegos Artificiales!`,
                  btnAction: {
                    action: () => {
                      history.push(PATHS.ACCOUNT_PAGE, { isPagePack: true });
                    },
                    title: "Compra paquetes",
                  },
                  description:
                    "¡Alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener Súper Cajas Navideñas llenas de recompensas premium! ",
                };
                break;
              case "BID_FREE":
                dataPopUp.current = {
                  backgroundPopup: iconBidSuccess,
                  title: `¡Has desbloqueado ${data.data.award.value} Pujas Gratis! ¡Haz tus pujas ahora para ganar un premio de alto valor esta semana y recolecta más fósforos para encender los Fuegos Artificiales ahora!`,
                  btnAction: {
                    action: () => {
                      history.push(PATHS.BID2_PAGE);
                    },
                    title: "Puja ahora",
                  },
                  description: "Tip Ganador: ¡Haz la puja más baja y única!!!",
                };
                break;
              case "SHELL":
                dataPopUp.current = {
                  backgroundPopup: iconShellSuccess,
                  title: `¡Encontraste ${data.data.award.value} Fuegos Artificiales! ¡Haz una puja ahora para reunir más fósforos y hacer que tus Fuegos Artificiales sean aún más mágicos!`,
                  btnAction: {
                    action: () => {
                      history.push(PATHS.BID2_PAGE);
                    },
                    title: "Puja ahora",
                  },
                  description:
                    "¡Alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener Súper Cajas Navideñas llenas de recompensas premium! ",
                };
                break;
              case "GOOD_LUCK":
                dataPopUp.current = {
                  backgroundPopup: iconGoodLuckSuccess,
                  title: `¡Encontraste la Campana Dorada! Buena suerte: Inténtalo de nuevo para tener otras oportunidades de ganar algo mágico...`,
                  isBottom: true,
                  btnAction: {
                    action: () => {
                      setOpen(false);
                    },
                    title: "Cerrar",
                  },
                  type: "GOOD_LUCK",
                };
                break;
              case "SPECIAL":
                dataPopUp.current = {
                  backgroundPopup: iconSpecialSuccess,
                  title: `<div>¡Felicitaciones! 🎉</div> Has ganado una Giftcard de S/.100. <span class="text-forcust-event">¡Bitel se comunicará contigo pronto para la entrega de tu premio!</span> ¡Sigue jugando que te esperan más sorpresas!`,
                };
                break;
              default:
                break;
            }
            setOpen(true);
            // mở hộp quà thành công
          }
        },
        onError: (error) => {
          console.error("Mutation failed:", error);
        },
      }
    );
  };

  const handleGetTitlePrize = () => {
    const TOTAL_PRIZE_SPE = 10;
    switch (TOTAL_PRIZE_SPE - resultSpeHis?.length) {
      case 10:
        return "Las 10 Gifcards aún estan en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el primer ganador!";
      case 1:
        return "Una Gifcard de S/.100 aún está en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el gran ganador!";
      case 0:
        return "Las 10 Gifcards ya tienen ganador. ¡Enciende más Fuegos artificiales para llevarte 3 premios especiales!";
      default:
        return `${
          TOTAL_PRIZE_SPE - resultSpeHis?.length
        } Gifcards de S/.100 siguen en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el gran ganador!`;
    }
  };

  return (
    <div id="christmas-tree-event">
      <PopupLogin isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <Snow />
      {open ? (
        <PopupComponents
          backgroundPopup={dataPopUp.current?.backgroundPopup}
          open={open}
          setOpen={setOpen}
          title={dataPopUp.current?.title}
          dataType={dataPopUp.current?.type}
          btnAction={dataPopUp.current?.btnAction}
          description={dataPopUp.current?.description}
        />
      ) : null}
      <div className="position-relative bg-event-mobile">
        <div className="event-body">
          <div className="envent-main-body">
            {!dataNoti?.isdn ? (
              <div style={{ height: "44px" }}></div>
            ) : (
              <div className="event-lm-noti-main">
                <img src={iconLoa} alt="loa" className="loa" />
                <div className="event-lm-noti-container">
                  <div className="event-lm-noti">
                    <div id="mar-quee-text">
                      <div>
                        <span className="event-lm-noti-content">
                          {dataNoti?.isdn &&
                          dataNoti?.award_name?.includes("20") ? (
                            `“${dataNoti?.isdn} acaba de ganar los premios: ${dataNoti?.award_name}”`
                          ) : (
                            <>{`“${
                              dataNoti ? dataNoti?.isdn : ""
                            } acaba de ganar los premios: ${
                              dataNoti?.award_name
                            }”
                        `}</>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div>
              <div className="position-relative">
                {/* <div className="icon-title-christmas">
                  <img src={IconTitleChristmas} alt="" />
                </div> */}
                <div className="position-relative">
                  <div className="lucky-moon-icon">
                    <div className="position-relative container-main-tree">
                      <div className="position-relative container-tree-event">
                        <div className="icon-title-christmas">
                          <img src={IconTitleChristmas} alt="" />
                        </div>
                        <img
                          src={IconPineTree}
                          alt="lucky moon"
                          className="lucky-moon-head z-index-2"
                        />
                        <div className="container-gift-tree z-index-4">
                          <div className="position-relative">
                            <div className="icon-gift-tree-1-1 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree1}
                                alt="icon-gift-tree-1-1"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.superGift)
                                }
                              />
                            </div>
                            <div className="icon-gift-tree-1-2 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree1}
                                alt="icon-gift-tree-1-2"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.superGift)
                                }
                              />
                            </div>
                            <div className="icon-gift-tree-3-1 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree3}
                                alt="icon-gift-tree-3-1"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.gift)
                                }
                              />
                            </div>
                            <div className="icon-gift-tree-5-1 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree5}
                                alt="icon-gift-tree-5-1"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.gift)
                                }
                              />
                            </div>
                            <div className="icon-gift-tree-3-2 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree3}
                                alt="icon-gift-tree-3-2"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.gift)
                                }
                              />
                            </div>
                            <div className="icon-gift-tree-5-2 zoom-in-out-box">
                              <img
                                className="cursor-pointer"
                                src={iconGiftTree5}
                                alt="icon-gift-tree-5-2"
                                onClick={() =>
                                  handleOpenGift(ID_GIFT_EVENT_2024.gift)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <img
                        src={iconTreeOpacity}
                        alt=""
                        className="tree-left z-index-1"
                      />
                      <img
                        src={iconTreeOpacity}
                        alt=""
                        className="tree-right z-index-1"
                      />
                      <img
                        src={iconSnow}
                        alt=""
                        className="icon-snow-event z-index-3 w-100"
                      />
                      <div className="super-container-chrismate position-relative">
                        <GiftSupper
                          statusEvent={statusEvent}
                          handleOpenGift={() => {}}
                        />
                        <div className="content-text-super">
                          {(!statusEvent?.open_super_left &&
                            statusEvent?.open_left) ||
                          (statusEvent?.open_super_left &&
                            !statusEvent?.open_left) ? (
                            <>
                              Te quedan {statusEvent?.open_super_left} Súper
                              Cajas Navideñas y {statusEvent?.open_left} Cajas
                              Navideñas{" "}
                              {+statusEvent?.open_left === 1 ||
                              +statusEvent?.open_super_left === 1
                                ? "normal"
                                : "normales"}
                              .{" "}
                              <div>
                                ¡Inicia sesión diariamente para obtener 3 Cajas
                                Navideñas gratis, o alcanza los objetivos del
                                Espectáculo de Fuegos Artificiales (50, 100 y
                                más) para obtener Súper Cajas Navideñas llenas
                                de recompensas premium!
                              </div>
                            </>
                          ) : null}
                          {statusEvent?.open_super_left &&
                          statusEvent?.open_left ? (
                            <>
                              Te quedan {statusEvent?.open_super_left || 0}{" "}
                              Súper Cajas Navideñas y{" "}
                              {statusEvent?.open_left || 0} Cajas Navideñas{" "}
                              {+statusEvent?.open_left === 1
                                ? "normal"
                                : "normales"}
                              .{" "}
                              <div>
                                ¡Inicia sesión diariamente para obtener 3 Cajas
                                Navideñas gratis, o alcanza los objetivos del
                                Espectáculo de Fuegos Artificiales (50, 100 y
                                más) para obtener Súper Cajas Navideñas llenas
                                de recompensas premium!
                              </div>
                            </>
                          ) : null}

                          {!statusEvent?.open_super_left &&
                          !statusEvent?.open_left ? (
                            <>
                              Has usado todas las Cajas Navideñas disponibles.
                              <div>
                                ¡Vuelve mañana para obtener 3 normales GRATIS o
                                alcanza las metas del Espectáculo de Fuegos
                                Artificiales (50, 100 y más) para obtener Súper
                                Cajas Navideñas llenas de recompensas premium!
                              </div>
                            </>
                          ) : null}

                          {/* You have 3 super and 1 Christmas Gift now. Upwrap to
                          take attractive prizes!!! */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="position-relative event-table-container">
                <div className="event-table">
                  <div>
                    <div className="event-table-item">
                      <div className="event-table-item-title">
                        <img src={img100winner} alt="" />
                      </div>
                      <div className="position-relative">
                        <img
                          src={iconSnowMan}
                          alt=""
                          className="icon-snow-man"
                        />
                        <Table
                          columns={columns}
                          dataSource={resultSpeHis || []}
                          pagination={false}
                          className="container-popup"
                          locale={{
                            emptyText: (
                              <Empty
                                description={
                                  <span
                                    style={{ color: "white", fontSize: "16px" }}
                                  >
                                    Sin Datos
                                  </span>
                                }
                              />
                            ),
                          }}
                        />
                      </div>
                    </div>
                    <div className="event-prizes">{handleGetTitlePrize()}</div>
                  </div>
                  <div className="event-lm-spin">
                    <div className="event-table-item">
                      <div className="event-table-item-title">
                        <img
                          src={iconTitleHistory}
                          alt=""
                          className="event-table-item-title-history"
                        />
                      </div>
                      <div className="container-table-your position-relative">
                        <img
                          src={iconHistoryTree}
                          alt=""
                          className="icon-history-tree"
                        />
                        <Table
                          columns={columnsSpin}
                          dataSource={resultHistory || []}
                          pagination={false}
                          locale={{
                            emptyText: (
                              <Empty
                                description={
                                  <span style={{ color: "white" }}>
                                    Sin Datos
                                  </span>
                                }
                              />
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
